import { GridColumnProps } from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";

let t = i18n.t;

export const BuyerOverviewGridColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "salesDate",
			title: t("Date"),
			width: "120px",

			cell: (props) => <GrideDateFormatter date={props.dataItem.salesDate} />,
		},
		//{
		//	field: "salesId",
		//	title: t("NumberShort"),
		//	width: "100px",
		//},
		//{
		//	field: "information",
		//	title: t("Information"),
		//	cell: (props) => <CellPopover {...props} />,
		//},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cell: (props) => <CellPopover {...props} />,
		},
		{
			field: "vesselNames",
			title: t("Vessels"),
			cell: (props) => <CellPopover {...props} />,
		},
		//{
		//	field: "registrationNumber",
		//	title: t("RegistrationIdShort"),
		//	width: "100px",
		//	cell: (props) => <CellPopover {...props} />,
		//},
		//{
		//	field: "packageNumber",
		//	title: t("Package"),
		//	width: "60px",
		//	cell: (props) => <CellPopover {...props} />,
		//},
		{
			field: "contractNumber",
			title: t("Contract"),
			width: "100px",
			cell: (props) => <CellPopover {...props} />,
		},
		{
			field: "salesNumber",
			title: t("Sale"),
			width: "100px",
			cell: (props) => <CellPopover {...props} />,
		},

		{
			field: "auctionId",
			title: t("AuctionId"),
			width: "100px",
		},
		{
			field: "salesType",
			title: t("Type"),
			width: "130px",
			headerClassName: "no-border",
		},
	];
	return gridItems;
};

export const purchaseOverviewDetailGridItems: GridColumnProps[] = [
	{
		//this will not be render
		field: "lineNumber",
		title: "Linje",
	},
	{
		field: "number",
		title: t("NumberShort"),
		width: "140px",
	},
	{ field: "description", title: t("Description") },
	{
		field: "vesselRegistrationId",
		title: t("VesselRegistrationId"),
		width: "110px",
	},
	{
		field: "vesselName",
		title: t("VesselName"),
	},

	{
		field: "netLiveWeightKg",
		title: t("Weight"),
		width: "120px",
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kg"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
	{
		field: "amount",
		title: t("Amount"),
		width: "120px",
		cells: {
			data: (props) => <NumericalCell {...props} unit={"kr"} />,
			headerCell: (props) => <NumericalHeader {...props} />,
		},

		// cell: (props) => <NumericalCell {...props} unit={"kr"} />,
		headerClassName: CLASSNAME.TableNumeric,
		className: `${CLASSNAME.TableNumeric} no-border`,
		// headerCell: (props) => <NumericalHeader {...props} />,
	},
	{
		width: "40px",
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
];
